/* ==========================================================================
   Luxury Preloader — Controller
   Loads the Lottie JSON via lottie-web (light SVG renderer), plays the
   animation once, then smoothly fades the overlay out after the configured
   minimum display time.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Guard: skip entirely in Theme Editor to avoid flash on section reload ---- */
  if (window.Shopify && window.Shopify.designMode) return;

  /* ---- Guard: reduced-motion preference ---- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MINIMUM_DISPLAY_MS = 600;
  var overlay = document.getElementById('luxury-preloader');
  if (!overlay) return;

  var container = document.getElementById('luxury-preloader-lottie');
  if (!container) return;

  var animDataUrl = overlay.getAttribute('data-anim-url');
  if (!animDataUrl) return;

  var startTime = Date.now();
  var animInstance = null;

  /* ---- Mark body so CSS hides app embeds (e.g. currency widget) ---- */
  document.body.classList.add('lux-preloading');

  /* ---- Dismiss logic ---- */
  function dismiss() {
    var elapsed = Date.now() - startTime;
    var remaining = Math.max(0, MINIMUM_DISPLAY_MS - elapsed);

    setTimeout(function () {
      /* Restore app embeds in sync with the overlay fade-out */
      document.body.classList.remove('lux-preloading');
      overlay.setAttribute('aria-hidden', 'true');

      /* Clean up after CSS transition ends (~500ms) */
      setTimeout(function () {
        if (animInstance) {
          animInstance.destroy();
          animInstance = null;
        }
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 600);
    }, remaining);
  }

  /* ---- Load lottie-web light build from CDN (only SVG renderer, ~26 KB gzip) ---- */
  var script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js';
  script.onload = function () {
    if (typeof lottie === 'undefined') {
      dismiss();
      return;
    }

    animInstance = lottie.loadAnimation({
      container: container,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: animDataUrl
    });

    /* Dismiss when animation completes its single loop */
    animInstance.addEventListener('complete', dismiss);

    /* Safety net: if animation JSON fails or is unexpectedly long, dismiss anyway */
    animInstance.addEventListener('data_failed', dismiss);
    setTimeout(dismiss, 3000);
  };

  /* If CDN fails, dismiss immediately so page is never blocked */
  script.onerror = dismiss;
  document.head.appendChild(script);

  /* ---- Fallback: if window loads before lottie even starts, guarantee dismiss ---- */
  window.addEventListener('load', function () {
    setTimeout(dismiss, MINIMUM_DISPLAY_MS);
  });
})();
